import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { modelBrand } from "../../lib/modelBrand";
import { useLang } from "../../contexts/LanguageContext";

/**
 * Public 5-model preview strip shown on the login/register screens so that
 * newcomers can see exactly which frontier models they'll get access to
 * before creating an account. Hits the public `/api/models` endpoint.
 */
export default function PublicModelStrip() {
  const { t } = useLang();
  const [models, setModels] = useState([]);

  useEffect(() => {
    let mounted = true;
    api.get("/models")
      .then(({ data }) => {
        if (mounted && Array.isArray(data)) setModels(data);
      })
      .catch(() => { /* silent — the strip just won't render */ });
    return () => { mounted = false; };
  }, []);

  if (!models.length) return null;

  return (
    <div className="mt-8" data-testid="auth-model-preview">
      <div className="label-eyebrow text-center mb-3 opacity-70">
        {t("auth.modelsHeader")}
      </div>
      <ul className="grid grid-cols-1 gap-2" data-testid="auth-model-list">
        {models.map((m) => {
          const brand = modelBrand(m.id);
          const { Icon } = brand;
          return (
            <li
              key={m.id}
              className={`${brand.accentClass} flex items-center gap-3 px-3 py-2 rounded-md border border-white/10 bg-white/[0.02]`}
              data-testid={`auth-model-${m.id}`}
            >
              <span className="w-2 h-2 rounded-full accent-dot flex-shrink-0" />
              <Icon className="w-3.5 h-3.5 text-white/70 flex-shrink-0" />
              <div className="min-w-0 flex-1 flex items-baseline justify-between gap-2">
                <span className="text-[12.5px] text-white/90 font-medium truncate">
                  {m.label}
                </span>
                <span className="label-eyebrow text-white/40 flex-shrink-0" style={{ fontSize: 9 }}>
                  {m.provider}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
      <div className="text-center mt-3 label-eyebrow opacity-50" style={{ fontSize: 10 }}>
        {t("auth.modelsFooter")}
      </div>
    </div>
  );
}
